import React from 'react';
import { ArrowRightIcon, DownloadIcon } from 'lucide-react';
import { SAMPLE_MEMO_PATH, SAMPLE_MEMO_DOWNLOAD_URL, PRODUCT_SCREENSHOTS } from '../../data/dgpt';
import { MEMO_EXPLAINER } from '../../data/sampleMemo';
import { SectionHeading } from '../ui/SectionHeading';
import { CtaButton } from '../ui/CtaButton';
import { Reveal } from '../ui/Reveal';
import { StepImage } from '../dgpt/product/StepImage';
export function SampleOutputSection() {
  return <section id="sample-memo" aria-labelledby="sample-heading" className="scroll-mt-20 border-b border-hairline-soft bg-surface" data-id="element-702" data-mp="2vny670umm9vk">
      <div className="mx-auto grid w-full max-w-[1320px] gap-12 px-4 py-20 sm:px-6 lg:grid-cols-[minmax(0,0.85fr)_minmax(0,1.15fr)] lg:gap-16 lg:px-8 lg:py-24" data-id="element-703" data-mp="34i4ji6kknzi9">
        <div className="flex flex-col" data-id="element-704" data-mp="30ivqx519q7oa">
          <SectionHeading eyebrow="Sample output" headingId="sample-heading" title="See what your investment team gets." description="A structured memo draft your team can check, challenge and finish. Read the full fictional example — no email required." data-id="element-705" data-mp="3eg0sarq1eid7" />
          <dl className="mt-10 flex flex-col gap-6" data-id="element-706" data-mp="367xjwvzb7zns">
            {MEMO_EXPLAINER.map((item, index) => <Reveal key={item.title} delay={index * 0.05} className="border-l-2 border-hairline pl-4" data-id="element-707" data-mp="3b6qtidbh76io" data-mpi={index}>
                <dt className="text-[15px] font-semibold text-text-primary" data-id="element-708" data-mp="3fa6rpe371exh">{item.title}</dt>
                <dd className="mt-1 text-sm leading-relaxed text-text-secondary" data-id="element-709" data-mp="3k7gr9mkar6z1">{item.body}</dd>
              </Reveal>)}
          </dl>
          <div className="mt-10 flex flex-col gap-3 sm:flex-row" data-id="element-710" data-mp="3p58h8b1dsj0l">
            <CtaButton href={SAMPLE_MEMO_PATH} event="sample_memo_open" eventParams={{
            placement: 'sample_section'
          }} size="lg" data-id="element-711" data-mp="3tythyauczr3h">
              Read Sample Memo
              <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-712" data-mp="6u3tdyxz12lt" />
            </CtaButton>
            {SAMPLE_MEMO_DOWNLOAD_URL ? <CtaButton href={SAMPLE_MEMO_DOWNLOAD_URL} event="sample_memo_download" eventParams={{
            placement: 'sample_section'
          }} variant="outline" size="lg" data-id="element-713" data-mp="bt810l58ysa1">
                <DownloadIcon className="h-4 w-4" aria-hidden="true" data-id="element-714" data-mp="2hm64t40bprpd" />
                Download PDF
              </CtaButton> : null}
          </div>
        </div>

        <Reveal delay={0.08} className="min-w-0" data-id="element-715" data-mp="2ct36kiklpu2u">
          <p className="mb-3 text-xs font-semibold uppercase tracking-[0.1em] text-text-secondary" data-id="element-716" data-mp="2rir6bfd4wkog">In the product</p>
          <StepImage image={PRODUCT_SCREENSHOTS.memo} data-id="element-717" data-mp="2mk7kdeyjj8w3" />
          <p className="mt-3 text-xs text-text-tertiary" data-id="element-718" data-mp="30l0i08k52k3f">Deal Memo and Business Risk reports in DiligenceGPT™.</p>
        </Reveal>
      </div>
    </section>;
}